import { render, staticRenderFns } from "./NwFormWeight.vue?vue&type=template&id=4dc03801&scoped=true&"
import script from "./NwFormWeight.vue?vue&type=script&lang=js&"
export * from "./NwFormWeight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc03801",
  null
  
)

export default component.exports